import { createSlice } from '@reduxjs/toolkit';

const FJSliceTextEditFloatingPanel = createSlice({
    name: 'f-panel',
    initialState: {
        editFloatingPanelVisible: false,
        editFloatingPanelPosition: { x: 0, y: 0 },
        showDelete: false,
        showRestore: false,
    },
    reducers: {
        setEditFloatingPanelVisible: (state, action) => {
            state.editFloatingPanelVisible = action.payload;
        },
        setEditFloatingPanelPosition: (state, action) => {
            state.editFloatingPanelPosition = action.payload;
        },
        setShowDelete: (state, action) => {
            state.showDelete = action.payload;
        },
        setShowRestore: (state, action) => {
            state.showRestore = action.payload;
        },
    },
});

export const { setEditFloatingPanelVisible, setEditFloatingPanelPosition, setShowDelete, setShowRestore } =
    FJSliceTextEditFloatingPanel.actions;
export default FJSliceTextEditFloatingPanel.reducer;
